import React, { Component } from 'react';
import T from 'prop-types';
// utils
import moment from 'moment';
// styles
import styles from './AudioPlayer.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.player = React.createRef();
    this.progressLine = React.createRef();
    this.state = {
      isPlaying: false,
      currentTime: 0
    };
  }

  togglePlay = () =>
    this.setState(prevState => {
      const nextStatePlaying = !prevState.isPlaying;

      if (nextStatePlaying) {
        this.intervalHandle = setInterval(this.tick, 250);
      }
      if (!nextStatePlaying) {
        clearInterval(this.intervalHandle);
      }

      nextStatePlaying
        ? this.player.current.play()
        : this.player.current.pause();

      return {
        isPlaying: nextStatePlaying
      };
    });

  onEnded = () => {
    clearInterval(this.intervalHandle);
    this.setState({ isPlaying: false, currentTime: 0 });
  };

  tick = () => {
    const player = this.player.current;
    this.setState({
      currentTime: player ? player.currentTime : 0
    });
  };

  handleRewind = e => {
    const lineProps = this.progressLine.current.getBoundingClientRect();
    const player = this.player.current;
    const duration = player ? player.duration : 0;
    const percentDuration = ((e.pageX - lineProps.x) * 100) / lineProps.width;
    const currentTime = (duration * percentDuration) / 100;
    this.setState({
      currentTime
    });
    player.currentTime = currentTime;
  };

  getTimeString = seconds =>
    moment()
      .startOf('day')
      .seconds(seconds)
      .format('mm:ss');

  render() {
    const { isPlaying, currentTime } = this.state;
    const { src, title, className = '' } = this.props;
    const player = this.player.current;
    const duration = player ? player.duration : 0;
    const durationString = this.getTimeString(duration);
    const currentTimeString = this.getTimeString(currentTime);

    const lineDuration = (currentTime * 100) / duration || 0;

    return (
      <div className={cx('player', className)}>
        <audio
          onDurationChange={this.onEnded}
          onEnded={this.onEnded}
          ref={this.player}
        >
          <source src={src} type="audio/mp3" />
        </audio>
        <div className={cx('wrapper')}>
          <button
            onClick={this.togglePlay}
            className={cx('play-btn', { playing: isPlaying })}
          >
            <span />
          </button>
          <div className={cx('info-container')}>
            <div className={cx('info')}>
              <p>{title}</p>
              <p>
                {currentTimeString}
                <span className={cx('duration')}>/{durationString}</span>
              </p>
            </div>
            <div
              ref={this.progressLine}
              onClick={this.handleRewind}
              className={cx('line')}
            >
              <span
                style={{ width: `${lineDuration}%` }}
                className={cx('line-progress')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  title: T.string.isRequired,
  src: T.string.isRequired,
  className: T.string
};

export default AudioPlayer;



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/AudioPlayer.jsx